module.exports = __webpack_public_path__ + "static/media/heart7.a3a11c64.png";